import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_dashboard_bar_chart = _resolveComponent("dashboard-bar-chart");
  const _component_empty_chart = _resolveComponent("empty-chart");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
    id: _ctx.legendTooltipId,
    class: "legendTooltip"
  }, null, 8, _hoisted_2), _createVNode(_component_dashboard_bar_chart, {
    "do-rotate": _ctx.doRotate,
    graphs: _ctx.graphs,
    height: _ctx.height,
    "legend-tooltip-id": _ctx.legendTooltipId,
    title: _ctx.title,
    width: _ctx.width
  }, null, 8, ["do-rotate", "graphs", "height", "legend-tooltip-id", "title", "width"])], 512), [[_vShow, _ctx.graphs[0]?.data?.length]]), _withDirectives(_createVNode(_component_empty_chart, {
    loading: _ctx.loading,
    url: _ctx.big ? '/public/images/charts/Bar-Large.png' : '/public/images/charts/Bar-Small.png'
  }, null, 8, ["loading", "url"]), [[_vShow, !_ctx.graphs[0]?.data?.length]])]);
}